/* eslint-disable react-doctor/advanced-event-handler-refs, react-doctor/exhaustive-deps, react-doctor/react-compiler-no-manual-memoization */
import { useState, useSyncExternalStore } from "react";

const EMPTY_OVERFLOW = { canScrollLeft: false, canScrollRight: false };

export function useScrollOverflow(
    scrollRef: React.RefObject<HTMLElement | null>,
) {
    const [store] = useState(() => ({
        snapshot: EMPTY_OVERFLOW,
        frame: null as number | null,
    }));
    return useSyncExternalStore(
        (listener) => {
            const el = scrollRef.current;
            if (!el) return () => {};
            const sync = () => {
                const canScrollLeft = el.scrollLeft > 0;
                const canScrollRight =
                    el.scrollLeft < el.scrollWidth - el.clientWidth - 1;
                if (
                    store.snapshot.canScrollLeft === canScrollLeft &&
                    store.snapshot.canScrollRight === canScrollRight
                )
                    return;
                store.snapshot = { canScrollLeft, canScrollRight };
                listener();
            };
            const update = () => {
                if (store.frame !== null) return;
                store.frame = requestAnimationFrame(() => {
                    store.frame = null;
                    sync();
                });
            };
            sync();
            el.addEventListener("scroll", update, { passive: true });
            const observer = new ResizeObserver(update);
            observer.observe(el);
            return () => {
                el.removeEventListener("scroll", update);
                observer.disconnect();
                if (store.frame !== null) {
                    cancelAnimationFrame(store.frame);
                    store.frame = null;
                }
            };
        },
        () => store.snapshot,
        () => EMPTY_OVERFLOW,
    );
}
